module.exports = __webpack_public_path__ + "img/arrow-point-to-right--white.5bdef584.svg";